import { render, staticRenderFns } from "./RuleStatusUpdatedModal.vue?vue&type=template&id=4984680f&"
import script from "./RuleStatusUpdatedModal.vue?vue&type=script&lang=js&"
export * from "./RuleStatusUpdatedModal.vue?vue&type=script&lang=js&"
import style0 from "./RuleStatusUpdatedModal.vue?vue&type=style&index=0&id=4984680f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports